import React from "react";

export const Loader: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-100 via-blue-200 to-sky-300">
      <div className="flex flex-col items-center justify-center gap-4">
        {/* Spinner */}
        <div className="relative w-12 h-12">
          <div className="absolute inset-0 border-4 border-gray-200 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-[var(--sidebar-primary)] border-t-transparent rounded-full animate-spin"></div>
        </div>
        {/* Loading text */}
        <p className="text-blue-950 font-medium">Loading...</p>
      </div>
    </div>
  );
};

export default Loader;
